import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const SearchPreferences = () => {
  return (
    <>
        <Box className="headingBtnWrap">
            <Typography variant="h1">Search Preferences</Typography>
        </Box>
    </>
  )
}

export default SearchPreferences
